import { render, staticRenderFns } from "./BaseFooterPositions.vue?vue&type=template&id=9365de40&scoped=true&"
import script from "./BaseFooterPositions.vue?vue&type=script&lang=js&"
export * from "./BaseFooterPositions.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterPositions.vue?vue&type=style&index=0&id=9365de40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9365de40",
  null
  
)

export default component.exports